/**
 * Fallback defaults for the CMS-editable OurStory + Travel pages. Used when
 * the public API is unreachable so the pages never render blank.
 */

export const defaultOurStoryContent = {
  eyebrow: 'Our Journey',
  title: 'A Love Story Written by God',
  imageBadge: 'Where It All Began',
  paragraphs: [
    "Our love journey began in church, at her cousin's christening—a place grounded in faith, family, and new beginnings. I didn't walk in that day expecting to find love, but God had already written the moment long before I arrived.",
    'During the ceremony, I noticed her sitting a few pews away—composed, graceful, and glowing in a way that seemed to soften everything around her. In that instant, something stirred within me. I knew I needed a reason to speak to her.',
    'So, when it was time for photos, I stepped forward and became the unofficial photographer. Then the rain began to fall—soft at first, then steady—as if heaven itself was leaning in to watch. I offered to walk her to her car, becoming her umbrella. In that quiet, rain-washed moment, something shifted between us.'
  ],
  quote: "What began as a drive in the rain became a journey in love. What started with a camera turned into a lifetime of memories. And what looked like coincidence was always God's timing. We didn't just find each other. We were led to each other.",
  signature: 'Forever & Always'
};

export const defaultScheduleContent = {
  eyebrow: 'Schedule',
  title: 'Order of Events',
  items: [
    { time: '2:00 PM – 2:30 PM', event: 'Guest Arrival',       description: 'Please arrive early to be seated before the ceremony begins.' },
    { key: 'ceremony',  time: '3:00 PM',           event: 'Ceremony Begins',     description: 'The exchange of vows and rings.' },
    { time: '4:00 PM',           event: 'Ceremony Concludes',  description: 'Photos and congratulations.' },
    { key: 'cocktail',  time: '4:30 PM – 6:00 PM', event: 'Cocktail Hour',       description: "Enjoy drinks and hors d\u2019oeuvres." },
    { key: 'reception', time: '6:00 PM',           event: 'Reception Begins',    description: 'Dinner service and toasts.' },
    { time: '8:00 PM',           event: 'First Dance & Dancing', description: 'Celebrate on the dance floor!' },
    { time: '10:30 PM',          event: 'Send-Off',            description: 'Bid farewell to the newlyweds.' }
  ]
};

// Cards on the Wedding Day Details section of the home page. The three cards
// are shared records with the Order of Events (`schedule_content`) rows that
// have matching keys — editing either surface updates the same record.
export const defaultEventDayContent = {
  eyebrow: 'Join Us',
  title: 'Wedding Day Details',
  venueLabel: 'The Venue',
  venue: {
    name: 'White & Sable',
    address: '15485 Baltimore St, Ham Lake, Minnesota',
    mapUrl: 'https://maps.google.com/?q=15485+Baltimore+St,+Ham+Lake,+Minnesota',
    mapButtonLabel: 'View on Google Maps'
  },
  cardOrder: ['ceremony', 'cocktail', 'reception'],
  dressCode: {
    label: 'Dress Code',
    value: 'Formal Attire',
    note: 'No jeans, please. Strictly enforced.'
  },
  backgroundImageUrl: 'https://customer-assets.emergentagent.com/job_wedding-bliss-71/artifacts/v0xl91e7_IMG_8451.jpeg',
  cards: [
    { key: 'ceremony',  title: 'The Ceremony',  time: '3:00 PM',           description: 'Join us as we exchange vows and begin our forever journey together.', icon: 'Calendar' },
    { key: 'cocktail',  title: 'Cocktail Hour', time: '4:30 PM – 6:00 PM', description: "Enjoy drinks, hors d\u2019oeuvres, and mingle with other guests.",   icon: 'Clock'    },
    { key: 'reception', title: 'Reception',     time: '6:00 PM Onwards',   description: 'Dinner, dancing, and celebration of love that will last a lifetime.', icon: 'Calendar' }
  ]
};

export const defaultTravelContent = {
  eyebrow: 'Getting There',
  title: 'Travel & Accommodations',
  cards: [
    { icon: 'Plane', title: 'By Air', subtitle: 'Minneapolis–Saint Paul International (MSP)', description: 'Approximately 45 minutes from the venue. Allow extra time for traffic.' },
    { icon: 'Car', title: 'By Car', subtitle: 'Rideshare & Personal Vehicles', description: 'Uber and Lyft are available. We encourage carpooling for convenience and safety.' },
    { icon: 'ParkingCircle', title: 'Parking', subtitle: 'Complimentary On-Site Parking', description: 'Free parking is available at the venue for all guests.' }
  ],
  arrivalNotice: 'Please arrive between 2:00 PM and 2:30 PM to be seated before the ceremony begins at 3:00 PM.',
  accommodationsIntro: "We've compiled a list of nearby accommodations for your convenience. Block codes will be shared closer to the wedding date.",
  hotels: [
    { name: 'The Westin Edina Galleria', type: 'Luxury', description: 'Upscale hotel with spa and fine dining options.', distance: '~25 min from venue' },
    { name: 'Hampton Inn Minneapolis-Roseville', type: 'Comfort Standard', description: 'Reliable comfort with complimentary breakfast.', distance: '~20 min from venue' },
    { name: 'Country Inn & Suites by Radisson, Blaine', type: 'Budget Friendly', description: 'Closest option with great value.', distance: '~10 min from venue' }
  ]
};
